var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M59.184,51.883,47.5,40.2a2.811,2.811,0,0,0-1.992-.82H43.6A24.366,24.366,0,1,0,39.378,43.6v1.91A2.811,2.811,0,0,0,40.2,47.5L51.883,59.184a2.8,2.8,0,0,0,3.973,0l3.317-3.317A2.826,2.826,0,0,0,59.184,51.883Zm-34.807-12.5a15,15,0,1,1,15-15A14.992,14.992,0,0,1,24.377,39.378Z","fill":"#fff"}));
}

SearchIcon.defaultProps = {"width":"60","height":"60.01","viewBox":"0 0 60 60.01"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
